var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "26px",
    viewBox: "0 0 32 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,3.0756 C30.823,3.5976 29.557,3.9506 28.229,4.1096 C29.585,3.2966 30.626,2.0106 31.116,0.4776 C29.848,1.2296 28.442,1.7756 26.947,2.0706 C25.749,0.7946 24.043,-0.0024 22.155,-0.0024 C18.529,-0.0024 15.59,2.9366 15.59,6.5626 C15.59,7.0766 15.648,7.5776 15.76,8.0586 C10.303,7.7846 5.466,5.1706 2.228,1.1986 C1.663,2.1686 1.339,3.2966 1.339,4.4996 C1.339,6.7766 2.498,8.7866 4.259,9.9636 C3.183,9.9296 2.171,9.6346 1.286,9.1426 C1.285,9.1706 1.285,9.1976 1.285,9.2256 C1.285,12.4066 3.548,15.0596 6.552,15.6626 C6.001,15.8126 5.421,15.8926 4.822,15.8926 C4.399,15.8926 3.988,15.8516 3.587,15.7756 C4.422,18.3836 6.847,20.2816 9.72,20.3346 C7.473,22.0956 4.642,23.1446 1.566,23.1446 C1.036,23.1446 0.514,23.1136 0,23.0536 C2.905,24.9156 6.356,26.0026 10.064,26.0026 C22.14,26.0026 28.743,15.9986 28.743,7.3236 C28.743,7.0386 28.737,6.7556 28.724,6.4736 C30.007,5.5486 31.12,4.3926 32,3.0756",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.02549b79475b0e1c223b7528f6d154b2.svg";
export { ForwardRef as ReactComponent };